import { render, staticRenderFns } from "./parkInfo.vue?vue&type=template&id=0c68a85f&scoped=true"
import script from "./parkInfo.vue?vue&type=script&lang=js"
export * from "./parkInfo.vue?vue&type=script&lang=js"
import style0 from "./parkInfo.vue?vue&type=style&index=0&id=0c68a85f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c68a85f",
  null
  
)

export default component.exports